import { Injectable } from '@angular/core';
import { PopoverController } from 'ionic-angular';
import { Settings } from '../settings';
import { UsermenuPopoverPage } from '../pages/usermenu-popover/usermenu-popover';

@Injectable()
export class UserProvider {
  userName: string;
  userSurname: string;
  userImage: string;
  userFirebaseId: string;
  userID: string;
  userType: string;
  userFirebaseData: any;
  userStatus: string = '';


  userMessageCount: number = 0;
  userPersonalID: any;

  userLoggedIn: boolean = false;

  userAppVersion: string = Settings.appVersion;

  userChatCount: number = 0;

  companyColorA: string;
  companyColorB: string;
  companyLogo: string;

  constructor(public popoverCtrl: PopoverController) {
    console.log('Hello UserProvider Provider');
  }

  setUserCompanyColorA(color: string) {
    this.companyColorA = color;
  }

  setUserCompanyColorB(color: string) {
    this.companyColorB = color;
  }

  setUserCompanyLogo(logo: string) {
    this.companyLogo = logo;
  }

  getUserCompanyColorA() {
    return this.companyColorA;
  }

  getUserCompanyColorB() {
    return this.companyColorB;
  }

  getUserCompanyLogo() {
    return this.companyLogo;
  }

  setUserChatCount(count: number) {
    this.userChatCount = count;
  }

  setUserStatus(status: string) {
    this.userStatus = status;
  }

  setUserFirebaseID(id: string) {
    this.userFirebaseId = id;
  }

  setUserName(name: string, surname: string) {
    this.userName = name;
    this.userSurname = surname;
  }

  setUserImage(img: string) {
    this.userImage = img;
  }

  setUserMessageCount(count: number) {
    this.userMessageCount = count;
  }

  setUserPersonalNumber(number: any) {
    this.userPersonalID = number;
  }

  setUserLogin(state: boolean) {
    this.userLoggedIn = state;
  }

  setUserType(type: string) {
      this.userType = type;
  }

  setUserAppVersion(version: string) {
      this.userAppVersion = version;
  }

  getUserAppVersion(){
      return this.userAppVersion;
  }

  setUserFirebaseData(data: any) {
      this.userFirebaseData = data;
  }

  getUserType(){
    return this.userType;
  }

  getUserLogin() {
    return this.userLoggedIn;
  }

  setUserID(id: string) {
    this.userID = id;
  }

  getUserID() {
    return this.userID;
  }

  getUserPersonalNumber() {
      return this.userPersonalID;
  }

  getUserMessageCount() {
    return this.userMessageCount;
  }

  getUserFirebaseID() {
    return this.userFirebaseId;
  }

  getUserName() {
    return this.userName;
  }

  getUserSurname() {
    return this.userSurname;
  }

  getUserImage() {
    return this.userImage;
  }

  getUserFirebaseData() {
    return this.userFirebaseData;
  }

  getUserChatCount() {
    return this.userChatCount;
  }

  getUserStatus() {
    return this.userStatus;
  }

  showUserMenu(myEvent) {
    const popover = this.popoverCtrl.create(UsermenuPopoverPage, {name: this.getUserName(), surname: this.getUserSurname(), message_count: this.getUserMessageCount(), personal_id: this.getUserPersonalNumber() }, {cssClass: 'user-popover-menu'});
    popover.present({
        ev: myEvent
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/user.ts